import { Form, InputNumber } from 'antd';
import { useStoreState, useStoreActions } from '../../../store';
import { useEffect } from 'react';
const { Item } = Form;
export const CostingOptionsForm = ({ editMode }: { editMode: boolean }) => {
  const form = Form.useFormInstance();
  const activePartner = useStoreState((state) => state.partner.activePartner);
  const sessionPartnerId = useStoreState((state) => state.session.user?.sessionPartnerId);
  const fetchActivePartner = useStoreActions((actions) => actions.partner.fetchPartner);

  useEffect(() => {
    if (sessionPartnerId) {
      fetchActivePartner(sessionPartnerId);
    }
  }, [sessionPartnerId, fetchActivePartner]);

  useEffect(() => {
    const data = form.getFieldsValue();
    const formDataSet = data.totalUpgradeCostTolerance || data.upgradeOverCheapestCostTolerance;
    if (activePartner?.costingConfigurationInfo && !editMode && !formDataSet) {
      const { totalUpgradeCostTolerance, upgradeOverCheapestCostTolerance } = activePartner.costingConfigurationInfo;
      form.setFieldsValue({
        totalUpgradeCostTolerance,
        upgradeOverCheapestCostTolerance,
      });
    }
  }, [form, activePartner, editMode]);

  return (
    <div>
      <Item
        extra={'The total cost you are willing to incur when upgrading shipments to meet a desired delivery date'}
        name="totalUpgradeCostTolerance"
        label="Total Upgrade Cost Tolerance"
      >
        <InputNumber prefix={'$'} />
      </Item>
      <Item
        extra={
          'How much you are willing to spend over the cheapest option when upgrading shipments to meet a desired delivery date'
        }
        name="upgradeOverCheapestCostTolerance"
        label="Upgrade Over Cheapest Cost Tolerance"
      >
        <InputNumber prefix={'$'} />
      </Item>
    </div>
  );
};
